import { Builder } from '@builder.io/react';

import FeatureGrid from './index.tsx';

Builder.registerComponent(FeatureGrid, {
  name: 'Feature Grid',
  inputs: [
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-black',
      enum: ['bg-black', 'bg-neutral-950', 'bg-neutral-900']
    },
    { name: 'title', type: 'string', defaultValue: '[Title]' },
    { name: 'subtitle', type: 'string', defaultValue: '[Subtitle]' },
    { name: 'overtitle', type: 'string', defaultValue: '[Overtitle]' },
    {
      name: 'features',
      type: 'list',
      subFields: [
        { name: 'header', type: 'string', defaultValue: '[Header]' },
        { name: 'text', type: 'string', defaultValue: '[text]' },
        {
          name: 'image',
          type: 'file',
          defaultValue: '/static/images/gradient.png'
        },
        { name: 'imageAlt', type: 'string', defaultValue: '[Alt]' },
        { name: 'imageWidth', type: 'number', defaultValue: '200' },
        { name: 'imageHeight', type: 'number', defaultValue: '200' }
      ]
    }
  ]
});
